import React from 'react';
import RealLogoRezenBlue from '../assets/img/splash-rezenBlue.gif';
import { cn } from '../utils/classUtils';

interface DefaultSplashV2Props {
  noPadding?: boolean;
  iconSize?: 'small' | 'large' | 'default';
}

const DefaultSplashV2: React.FC<DefaultSplashV2Props> = ({ noPadding }) => {
  return (
    <div
      className={cn('w-full h-full flex items-center justify-center', {
        'p-5': !noPadding,
      })}
      title='spinning-loader'
    >
      <img src={RealLogoRezenBlue} alt='' />
    </div>
  );
};

export default DefaultSplashV2;
